export default {
  baseUrl: "/api"
};
